<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">List</span>
        <h3 class="page-title">Kartu</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom">
              <button type="button" class="btn-primary btn-sm" @click="add()" style="padding:0.15rem 0.5rem !important">Tambah Baru</button>
          </div>
          <div class="card-body p-0 pb-3 text-center" style="overflow-x:scroll">
            <d-row style="margin:auto">
            <d-col md="3"  class="form-group" style="text-align:left">
              Menampilkan
              <select v-model="ipp" >
                <option value=5 selected>5 item</option>
                <option value=10>10 item</option>
                <option value=15>15 item</option>
                <option value=20>20 item</option>
                <option value=0>Semua</option>
              </select>
            </d-col>
            <d-col md="3"  class="form-group">
                <d-select v-model="status" :options="statuses" style="padding-left:1px" />
            </d-col>
            <d-col md="6"  class="form-group">
              <d-form-input type="text" id="feInputAddress" placeholder="Search" v-model.trim="search" />
            </d-col>
            </d-row>
        <b-table
            :data="isEmpty ? [] : data"
            :loading="loading"
            :mobile-cards="hasMobileCards"
            paginated
            backend-pagination
            :total="total"
            :per-page="perPage"
            :current-page="page"
            @page-change="onPageChange"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"

            backend-sorting
            :default-sort-direction="defaultSortOrder"
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"
            >

            <template slot-scope="props">
                <b-table-column field="id" label="Id" sortable>
                    <button type="button" class="btn-primary btn-sm" @click="open_data(props.row.id)" style="padding:0.15rem 0.5rem !important"><i class="material-icons">edit</i></button>
                    <span class="tag is-success">
                    {{ props.row.id }}
                    </span>
                </b-table-column>
                <b-table-column field="rfid" label="RFID" sortable>
                    {{ props.row.rfid }}
                </b-table-column>
                <b-table-column field="created_at" label="Tanggal Input" sortable>
                    {{ props.row.created_at }}
                </b-table-column>
                <b-table-column field="updated_at" label="Tanggal Update" sortable>
                    {{ props.row.updated_at }}
                </b-table-column>
                <b-table-column field="fullname" label="Nama Peserta" sortable>
                    {{ props.row.fullname }}
                </b-table-column>
                <b-table-column field="status" label="Status" sortable>
                    {{ props.row.status=='0'?'Hilang': 'Aktif' }}
                </b-table-column>
            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                icon="emoticon-sad"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>Nothing here.</p>
                    </div>
                </section>
            </template>
            <template slot="footer" >
              <th>Total Aktif: </th>
              <th  style="text-align:right">{{ total_active }}</th>
              <th>Total Kosong: </th>
              <th  style="text-align:right">{{ total_blank }}</th>
              <th>Total Hilang: </th>
              <th  style="text-align:right">{{ total_lost }}</th>
            </template>
        </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import env from '../env.vue';

    export default {
        data() {
            return {
                data:[],
                list:[],
                index:0,
                images:[],
                isEmpty: false,
                isHoverable: true,
                loading: false,
                hasMobileCards: true,
                sortField:'name',
                sortOrder:'asc',
                sortIcon:'arrow-up',
                sortIconSize:'is-small',
                sort:'name',
                defaultSortOrder:'asc',
                page:1,
                perPage:5,
                total:2,
                total_active:0,
                total_lost:0,
                total_blank:0,
                filename:'',
                ipp:5,
                search:'',
                status:'',
                statuses:[
                { value: '1', text:'Aktif' },
                { value: '0', text:'Hilang' },
                { value: '', text:'Semua' },
                ],
            }
        },
        watch:{
          status(val){
           this.update_data();
          },
          ipp(){
           if (this.ipp>0) this.perPage=this.ipp*1
           else this.perPage=this.total*1
           this.update_data();
          },
          search(){
           if(this.search.length>2||!this.search.length)this.update_data()
          },
        },
        methods:{
          add(id){
            this.$router.push({name:'card-form',params:{id:0},query:{id:0}});
          },
          open_data(id){
            this.$router.push({name:'card-form',params:{id:id},query:{id:id}});
          },
          save_state(){
            var arr={
              page:this.page,
              perPage:this.perPage,
              total:this.total,
              ipp:this.ipp,
              search:this.search,
              sortField:this.sortField,
              sortOrder:this.sortOrder,
            };
            this.$store.commit('list',arr);
          },
          load_state(){
            var arr=this.$store.state.list;
            if ( arr==null ) return;
            this.page=arr.page;
            this.perPage=arr.ipp>0 ? arr.perPage : arr.total;
            this.total=arr.total;
            this.ipp=arr.ipp;
            this.search=arr.search;
            this.sortField=arr.sortField;
            this.sortOrder=arr.sortOrder;
          },
          onPageChange(page){
           this.page=page;
           this.update_data();           
          },
          onSort(field,order){
           if ( !this.loading ){           
            this.sortField=field;
            this.sortOrder=order;
            this.update_data();
           }
          },
          update_data(){
           this.loading=true;           
           this.save_state();
           this.axios.post( env.server+'/card-list',{
             start: this.page,
             length: this.perPage>0 ? this.perPage: this.total,
             sort: this.sortField,
             sort_order: this.sortOrder,
             scfilter: this.search,
             status: this.status!=='' ? ''+ parseInt(this.status):'',
           }).then(
             resp=>{
               resp.data=JSON.parse(resp.data);
               this.loading=false;
               this.data=resp.data.data.items;
               this.total=resp.data.data.total_results;
               for (var i=0; i<this.data.length; i++ ){
                 this.data[i].idx=i;
               }
               this.total_active=resp.data.data.total_active;  
               this.total_blank=resp.data.data.total_blank;  
               this.total_lost=resp.data.data.total_lost;  
             }
           );
          },
        },
        mounted(){
          this.load_state();
          this.update_data();
        },
    }
</script>
